export default {
  OVERRIDE_PAGE: 'override-page',
  COPY_PAGE: 'copy-page',
};
